import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../services/api"; // ✅ Using service

const ChangePassword = () => {
  const { t } = useTranslation();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");

      await api.put(
        "/users/me/password",
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert(t("account.passwordChanged"));
      setCurrentPassword("");
      setNewPassword("");
    } catch (error) {
      console.error("Change password error:", error);
      alert(
        error.response?.data?.message || t("account.passwordChangeFailed")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">{t("nav.changePassword")}</h2>
      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>{t("account.currentPassword")}</label>
          <input
            type="password"
            className="form-control"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label>{t("auth.newPassword")}</label>
          <input
            type="password"
            className="form-control"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={loading}
        >
          {loading ? t("account.changing") : t("nav.changePassword")}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
